<div class="d-flex justify-content-center mb-3 position-relative">
  <img class="img-migration" style="height: 216px;" src="../../../assets/images/migration-img-1.png" alt="">
  <i *ngIf="!migrationMandatory && currentStep !== 0" class="material-icons close-icon" (click)="close()">close</i>
</div>

<div class="content-wrapper" [ngClass]="'step-' + currentStep">
  <div class="content-container d-flex flex-column align-items-center justify-content-center" [ngSwitch]="currentStep">
    <ng-container *ngSwitchCase="0">
      <h4 class="title-migration mb-4">Sua forma de acesso mudou!</h4>
      <span class="description-migration text-center mb-4">
        Para sua segurança e praticidade, seu acesso à Auto Arremate agora é feito com a sua
        <strong class="highlight">conta sbX</strong>
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="1">
      <h4 class="title-migration mb-4">Máxima segurança em poucos cliques</h4>
      <span class="description-migration text-center mb-4">
        Acesse com sua <strong>conta digital sbX</strong> e aproveite a plataforma com a máxima segurança.
      </span>
      <div class="d-flex align-items-center" style="gap: 6px;">
        <i class="fa-solid fa-info-circle" style="color: #FFC727; font-size: 25px;"></i>
        <span style="font-size: 16px;"><strong>Data limite para migração:</strong> {{ mandatoryDate | date:'dd/MM/yyyy' }}</span>
      </div>
    </ng-container>
  </div>

  <div *ngIf="currentStep === 0" class="d-flex align-items-center justify-content-center mb-3">
    <button class="next-button" (click)="nextStep()">
      <span style="font-size: 16px; font-weight: 300;  font-family: 'Raleway';">Continuar</span>
      <i class="fa-solid fa-chevron-right" style="font-size: 16px;"></i>
    </button>
  </div>
  <div *ngIf="currentStep === 1" class="d-flex align-items-center justify-content-center mb-3">
    <button class="superbid-button" (click)="redirectSuperbidAccounts()">
      <span style="font-size: 16px; font-weight: 300;  font-family: 'Raleway';">Logar com minha conta sbX</span>
    </button>
  </div>
  
  <div class="d-flex align-items-center justify-content-center mb-2" *ngIf="migrationMandatory">
    <span class="back-button cursor-pointer" (click)="backToLogin()">Voltar para o login</span>
  </div>
</div>
